import { GeneralFilter } from '~/core/features/filtering/GeneralFilter';
import { ResetFilterControlsPayload } from '~/core/state/actions';
import { State } from '~/core/state/types/state';

const ResetFilterControls = (state: State, payload: ResetFilterControlsPayload): State => {
    const filter = new GeneralFilter();
    console.log('this is the reducer function - this should update the state, should run second');

    return {
        ...state,
        controls: state.controls.map((querySetControls) => {
            if (querySetControls.querySet.identifier !== payload.querySetIdentifier) {
                return querySetControls;
            }
            return {
                ...querySetControls,
                filters: querySetControls.filters.map((filterControls) => {
                    if (filterControls.identifier === payload.filterIdentifier) {
                        return filter.resetControlsState(filterControls);
                    }

                    return filterControls;
                }),
            };
        }),
    };
};

export default ResetFilterControls;
